import { useMemo } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

interface Props {
    size?: 'extra-small' | 'small' | 'medium' | 'large';
    className?: string;
}
const Loading = ({ size = 'medium', className = '' }: Props) => {
    const loaderSize = useMemo(() => {
        switch (size) {
            case 'extra-small':
                return 24;
            case 'small':
                return 32;
            case 'medium':
                return 40;
            case 'large':
                return 48;

            default:
                return 40;
        }
    }, [size]);
    return (
        <div className={`flex w-full items-center justify-center ${className}`} data-testid="loading" role="loading">
            <CircularProgress size={loaderSize} />
        </div>
    );
};

export default Loading;
